/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import EmailTemplatesEmailTemplate from './EmailTemplatesEmailTemplate';

/**
 * The EmailTemplatesBody model module.
 * @module model/EmailTemplatesBody
 * @version v0.3
 */
export default class EmailTemplatesBody {
  /**
   * Constructs a new <code>EmailTemplatesBody</code>.
   * @alias module:model/EmailTemplatesBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EmailTemplatesBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EmailTemplatesBody} obj Optional instance to populate.
   * @return {module:model/EmailTemplatesBody} The populated <code>EmailTemplatesBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EmailTemplatesBody();
      if (data.hasOwnProperty('email_template'))
        obj.emailTemplate = EmailTemplatesEmailTemplate.constructFromObject(data['email_template']);
    }
    return obj;
  }
}

/**
 * @member {module:model/EmailTemplatesEmailTemplate} emailTemplate
 */
EmailTemplatesBody.prototype.emailTemplate = undefined;
